import React from "react";
import{ useStateManager, DisabledPrompt} from "bcms-react";
import "./styles.css";

/**
 * @function ImportFileMappingPreviewMobileTable
 * @return {React.Component}
 * @exported true
 * @description Mobile import file mapping preview mobile table for the ImportFileMappingPreviewWidget.
 */
export default function ImportFileMappingPreviewMobileTable(props) {
    const { data } = useStateManager();

    // Only show the first ach participant.
    const firstParticipant = data.achToParticipants.participants[0];
    const participants = firstParticipant ? [ firstParticipant ] : [];
    const columns = data.selectedColumns;

    const columnLabels = columns.reduce((acc, item) => {
        const optionName = item.value.value.replace("(Required)", "").trimEnd();
        acc.push({ value: optionName });
        return acc;
    }, []);

    const rows = participants.reduce((acc, item, i) => {
        acc.push(
            <React.Fragment key="0">
                <ImportFileMappingPreviewMobileTableRow participant={ item } columnLabel={ columnLabels[0].value } columnText={ item.participant.participantName } />
                <ImportFileMappingPreviewMobileTableRow participant={ item } columnLabel={ columnLabels[1].value } columnText={ item.participant.number } />
                <ImportFileMappingPreviewMobileTableRow participant={ item } columnLabel={ columnLabels[2].value } columnText={ item.participant.routing } />
                <ImportFileMappingPreviewMobileTableRow participant={ item } columnLabel={ columnLabels[3].value } columnText={ item.amount.format({hasCents: false}).slice(1) } />
                <ImportFileMappingPreviewMobileTableRow participant={ item } columnLabel={ columnLabels[4].value } columnText={ item.participant.transactionCode } className="last-row" />
            </React.Fragment>
        );
        return acc;
    }, []);

    return (
        <div className="import-file-mapping-preview-mobile-table">
            { rows }
        </div>
    );
}

/**
 * @function ImportFileMappingPreviewMobileTableRow
 * @return {React.Component}
 * @exported false
 * @description Mobile import file mapping preview mobile table row for the ImportFileMappingPreviewMobileTable.
 */
function ImportFileMappingPreviewMobileTableRow(props) {
    const className = props.className ?? "";
    const columnLabel = props.columnLabel ?? "(Exclude Column)";
    const columnText = props.columnText ?? "[columnText]";

    return (
        <div className={`import-file-mapping-preview-mobile-table-row ${className}`}>
            <div className="flex-container align-center column-container">
                <div className="set-width">
                    <span className="column-label">{ columnLabel }:</span>
                </div>
                <div className="set-width">
                    <span className="column-text">{columnText}</span>
                </div>
            </div>
        </div>
    );
}